var map = {
	"pages/account/account.module": [
		1243,
		44
	],
	"pages/account/modal-cancel-subscription/modal-cancel-subscription.module": [
		1245,
		81
	],
	"pages/bank-account/bank-account.module": [
		1244,
		22
	],
	"pages/bank-account/modal-bank-details/modal-bank-details.module": [
		1248,
		18
	],
	"pages/bank-account/modal-banks/modal-banks.module": [
		1246,
		101
	],
	"pages/bank-account/modal-manager-info/modal-manager-info.module": [
		1247,
		43
	],
	"pages/call-attendant/call-attendant.module": [
		1251,
		41
	],
	"pages/call-attendant/call-config/call-attendant-config.module": [
		1249,
		27
	],
	"pages/call-attendant/modal-service-details/modal-service-details.module": [
		1250,
		100
	],
	"pages/category/category.module": [
		1253,
		34
	],
	"pages/category/modal-add-category/modal-add-category.module": [
		1252,
		60
	],
	"pages/category/products/products.module": [
		1255,
		40
	],
	"pages/category/products/registration/modal-add-complement/modal-add-complement.module": [
		1254,
		33
	],
	"pages/category/products/registration/modal-add-complement/modal-add-option/modal-add-option.module": [
		1256,
		65
	],
	"pages/category/products/registration/modal-help-complement/modal-help-complement.module": [
		1258,
		117
	],
	"pages/category/products/registration/product-registration.module": [
		1257,
		0
	],
	"pages/coupons/coupon-registration/coupon-registration.module": [
		1259,
		10
	],
	"pages/coupons/coupons.module": [
		1261,
		26
	],
	"pages/coupons/modal-customers/modal-customers.module": [
		1260,
		59
	],
	"pages/coupons/modal-products/modal-products.module": [
		1262,
		99
	],
	"pages/customers/customers.module": [
		1263,
		5
	],
	"pages/email-confirmation/email-confirmation.module": [
		1266,
		80
	],
	"pages/forgot-password/forgot-password.module": [
		1264,
		98
	],
	"pages/help/help.module": [
		1265,
		79
	],
	"pages/home/home.module": [
		1270,
		31
	],
	"pages/login/login.module": [
		1267,
		97
	],
	"pages/maintenance/maintenance.module": [
		1268,
		116
	],
	"pages/map/map.module": [
		1269,
		96
	],
	"pages/modal-business-type/modal-business-type.module": [
		1272,
		78
	],
	"pages/modal-card/modal-card.module": [
		1271,
		77
	],
	"pages/modal-countries/modal-countries.module": [
		1273,
		95
	],
	"pages/modal-custom-alert/modal-custom-alert.module": [
		1276,
		76
	],
	"pages/modal-notification-permission/modal-notification-permission.module": [
		1274,
		115
	],
	"pages/modal-receivable-news/modal-receivable-news.module": [
		1275,
		114
	],
	"pages/modal-reservation-hours-config/modal-reservation-hours-config.module": [
		1278,
		113
	],
	"pages/modal-stores/modal-stores.module": [
		1277,
		94
	],
	"pages/modal-translation/modal-translation.module": [
		1279,
		69
	],
	"pages/modal-trial-expired/modal-trial-expired.module": [
		1283,
		112
	],
	"pages/modal-update-password/modal-update-password.module": [
		1280,
		93
	],
	"pages/modal-welcome/modal-welcome.module": [
		1281,
		111
	],
	"pages/notification-config/notification-config.module": [
		1282,
		75
	],
	"pages/orders/modal-change-table/modal-change-table.module": [
		1284,
		92
	],
	"pages/orders/modal-order-detail/modal-order-detail.module": [
		1288,
		57
	],
	"pages/orders/modal-print-hint/modal-print-hint.module": [
		1285,
		110
	],
	"pages/orders/modal-reject-order/modal-reject-order.module": [
		1286,
		39
	],
	"pages/orders/order-reservation-config/first-step/order-reservation-first-step.module": [
		1287,
		30
	],
	"pages/orders/order-reservation-config/second-step/order-reservation-second-step.module": [
		1289,
		56
	],
	"pages/orders/order-reservation-config/third-step/order-reservation-third-step.module": [
		1290,
		29
	],
	"pages/orders/orders-config/modal-delivery/modal-delivery.module": [
		1291,
		55
	],
	"pages/orders/orders-config/modal-delivery/modal-fee/modal-fee.module": [
		1292,
		68
	],
	"pages/orders/orders-config/orders-config.module": [
		1293,
		13
	],
	"pages/orders/orders.module": [
		1294,
		14
	],
	"pages/orders/popover-order-filter/popover-order-filter.module": [
		1295,
		109
	],
	"pages/passwords/passwords.module": [
		1296,
		91
	],
	"pages/place/bind-store/bind-store.module": [
		1302,
		90
	],
	"pages/place/details/place-details.module": [
		1298,
		12
	],
	"pages/place/home/place-home.module": [
		1299,
		38
	],
	"pages/place/modal-store-detail/modal-store-detail.module": [
		1297,
		89
	],
	"pages/place/statistics/statistics.module": [
		1301,
		9
	],
	"pages/plan-subscription/modal-payment/modal-payment.module": [
		1300,
		37
	],
	"pages/plan-subscription/plan-subscription.module": [
		1303,
		36
	],
	"pages/queue/modal-queue-detail/modal-queue-detail.module": [
		1304,
		67
	],
	"pages/queue/modal-save-queue/modal-save-queue.module": [
		1305,
		58
	],
	"pages/queue/queue-config/queue-config.module": [
		1306,
		74
	],
	"pages/queue/queue.module": [
		1307,
		16
	],
	"pages/rating/modal-answer-comment/modal-answer-comment.module": [
		1308,
		66
	],
	"pages/rating/order-rating/order-rating.module": [
		1309,
		73
	],
	"pages/rating/rating.module": [
		1310,
		21
	],
	"pages/receivables/legacy/modal-forecast-details/modal-forecast-details.module": [
		1311,
		108
	],
	"pages/receivables/legacy/receivables.module": [
		1313,
		4
	],
	"pages/receivables/payment-account/modal-config-withdrawal/modal-config-withdrawal.module": [
		1312,
		64
	],
	"pages/receivables/payment-account/modal-kyc-process/modal-kyc-process.module": [
		1319,
		88
	],
	"pages/receivables/payment-account/modal-withdraw/modal-withdraw.module": [
		1314,
		42
	],
	"pages/receivables/payment-account/payment-account.module": [
		1315,
		1
	],
	"pages/reservation/modal-cancel-reservation/modal-cancel-reservation.module": [
		1316,
		72
	],
	"pages/reservation/modal-detail-reservation/modal-detail-reservation.module": [
		1317,
		87
	],
	"pages/reservation/modal-report/modal-report-reservation.module": [
		1318,
		107
	],
	"pages/reservation/modal-save-reservation/modal-save-reservation.module": [
		1320,
		17
	],
	"pages/reservation/modal-select-hours/modal-select-hours.module": [
		1321,
		86
	],
	"pages/reservation/reservation-config/availability-calendar/availability-calendar.module": [
		1323,
		35
	],
	"pages/reservation/reservation-config/available-hours/available-hours.module": [
		1322,
		54
	],
	"pages/reservation/reservation-config/charge-step/charge-reservation-step.module": [
		1324,
		15
	],
	"pages/reservation/reservation-config/general-step/general-step.module": [
		1325,
		53
	],
	"pages/reservation/reservation-config/reservation-config.module": [
		1326,
		7
	],
	"pages/reservation/reservation-config/special-dates/new-special-date-config/new-special-date-config.module": [
		1327,
		8
	],
	"pages/reservation/reservation-config/special-dates/special-date-availability/special-date-availability.module": [
		1328,
		52
	],
	"pages/reservation/reservation-config/special-dates/special-dates.module": [
		1329,
		51
	],
	"pages/reservation/reservation-config/table-type/available-table-hours/available-table-hours.module": [
		1330,
		50
	],
	"pages/reservation/reservation-config/table-type/modal-table-sectors/modal-table-sectors.module": [
		1331,
		49
	],
	"pages/reservation/reservation-config/table-type/table-seats/table-seats.module": [
		1332,
		48
	],
	"pages/reservation/reservation-list/reservation-list.module": [
		1333,
		20
	],
	"pages/settings/settings.module": [
		1337,
		85
	],
	"pages/statistics/modal-report/modal-report.module": [
		1334,
		106
	],
	"pages/statistics/orders/statistics.module": [
		1335,
		2
	],
	"pages/statistics/reservations/reservation-statistics.module": [
		1336,
		3
	],
	"pages/store/details/store-details.module": [
		1338,
		11
	],
	"pages/store/registration/store-registration.module": [
		1339,
		32
	],
	"pages/store/store-intern-registration/store-intern-registration.module": [
		1340,
		47
	],
	"pages/tables-payment/modal-customer-orders/modal-customer-orders.module": [
		1343,
		25
	],
	"pages/tables-payment/popover-filter/popover-filter.module": [
		1342,
		105
	],
	"pages/tables-payment/popover-orders-table/popover-orders-table.module": [
		1341,
		104
	],
	"pages/tables-payment/tables-payment.module": [
		1344,
		71
	],
	"pages/tables/modal-add-tables/modal-add-tables.module": [
		1345,
		28
	],
	"pages/tables/modal-qrcode/modal-qrcode.module": [
		1346,
		70
	],
	"pages/tips/tips-item/tips-item.module": [
		1347,
		84
	],
	"pages/tips/tips.module": [
		1348,
		83
	],
	"pages/tools/meta-pixel/meta-pixel.module": [
		1349,
		62
	],
	"pages/tools/tools.module": [
		1350,
		61
	],
	"pages/user/modal-add-user/modal-add-user.module": [
		1351,
		46
	],
	"pages/user/user.module": [
		1353,
		45
	],
	"pages/wallet/modal-auto-recharge/modal-auto-recharge.module": [
		1352,
		24
	],
	"pages/wallet/modal-manual-recharge/modal-manual-recharge.module": [
		1354,
		19
	],
	"pages/wallet/statement/wallet-statement.module": [
		1356,
		6
	],
	"pages/wallet/wallet.module": [
		1355,
		23
	],
	"pages/whats-new/whats-new.module": [
		1357,
		82
	],
	"shared/components/business-hour/modal-business-hours/modal-business-hours.module": [
		1358,
		63
	],
	"shared/components/popover-tour/popover-tour.module": [
		1359,
		103
	],
	"shared/components/popover/popover.module": [
		1360,
		102
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 444;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 444
// module chunks = 118